import React from 'react';
import { Card, CardContent, Typography, Button, CardActions, Box, Chip } from '@mui/material';
import ArrowOutwardRoundedIcon from '@mui/icons-material/ArrowOutwardRounded';

const ProjectCard = ({ title, description, image, onLearnMore, outline, tag, year }) => {
  return (
    <Card
      role="button"
      tabIndex={0}
      onClick={onLearnMore}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          onLearnMore();
        }
      }}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        borderRadius: 4,
        backgroundColor: 'rgba(10, 17, 34, 0.95)',
        border: outline ? '1px solid rgba(96, 165, 250, 0.45)' : '1px solid rgba(148, 163, 184, 0.16)',
        boxShadow: '0 26px 56px rgba(15, 23, 42, 0.32)',
        cursor: 'pointer',
        overflow: 'hidden',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: '0 36px 70px rgba(37, 99, 235, 0.32)',
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          pt: '62%',
          backgroundImage: `url(${image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            background:
              'linear-gradient(180deg, rgba(15, 23, 42, 0) 0%, rgba(15, 23, 42, 0.75) 100%)',
          }}
        />
        {year && (
          <Chip
            label={year}
            size="small"
            sx={{
              position: 'absolute',
              top: 16,
              left: 40,
              backgroundColor: 'rgba(37, 99, 235, 0.9)',
              color: '#f8fafc',
              border: '1px solid rgba(191, 219, 254, 0.6)',
              fontWeight: 600,
              letterSpacing: 0.5,
            }}
          />
        )}
      </Box>

      <Box sx={{ flexGrow: 1 }}>
        <CardContent
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            pt: 3,
            pb: 2.75,
          }}
        >
          {tag && (
            <Chip
              label={tag}
              variant="outlined"
              size="small"
              sx={{
                alignSelf: 'flex-start',
                color: 'text.secondary',
                borderColor: 'rgba(148, 163, 184, 0.25)',
                backgroundColor: 'rgba(15, 23, 42, 0.6)',
              }}
            />
          )}
          <Typography variant="h6" component="div" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.55 }}>
            {description}
          </Typography>
        </CardContent>
      </Box>
      <CardActions sx={{ justifyContent: 'flex-end', px: 3, pb: 3, pt: 1 }}>
        <Button
          size="small"
          color="primary"
          endIcon={<ArrowOutwardRoundedIcon fontSize="small" />}
          onClick={(event) => {
            event.stopPropagation();
            onLearnMore();
          }}
        >
          Explore project
        </Button>
      </CardActions>
    </Card>
  );
};

export default ProjectCard;
